/**
 * Types for the Workspace Audit Trail UI (sl-wmbt.5.1 + sl-wmbt.5.2)
 */

export interface AuditEvent {
  id: string;
  workspaceId: string;
  userId: string | null;
  userEmail: string | null;
  userName: string | null;
  userAvatarUrl: string | null;
  category: string;
  action: string;
  targetType: string | null;
  targetId: string | null;
  targetName: string | null;
  details: unknown;
  ipAddress: string | null;
  createdAt: string;
}

export interface AuditEventPage {
  edges: { node: AuditEvent; cursor: string }[];
  pageInfo: { hasNextPage: boolean; endCursor: string | null };
}

export interface AuditFilter {
  category?: string;
  userId?: string;
  /** sl-97oo: Filter by user group — matches all members of the group. */
  groupId?: string;
  dateFrom?: string;
  dateTo?: string;
}

// sl-wmbt.6.3: added admin, oauth, platform categories
export const AUDIT_CATEGORIES = [
  'auth',
  'rbac',
  'membership',
  'ai',
  'automation',
  'workflow',
  'mail',
  'data',
  'billing',
  'admin',
  'oauth',
  'platform',
  'settings',
] as const;

export type AuditCategory = (typeof AUDIT_CATEGORIES)[number];
